module.exports = __webpack_public_path__ + "img/graduation.fae3502d.png";